import React from 'react';
import { useReportId } from '../../hooks/useReportId';
import { ExportBuilder } from './ExportBuilder';
import {ExportContext} from './ExportContext';

export type ExportProviderProps = { triggerValues: unknown[] };

export const ExportProvider: React.FC<ExportProviderProps> = props => {
  const [hashTriggers, setHashTrigger] = React.useState(JSON.stringify(props.triggerValues));
  const reportId = useReportId();
  const builder = React.useMemo(() => new ExportBuilder(reportId), [reportId, hashTriggers]);
  const children = React.useMemo(() => builder === null ? null : props.children, [builder]);
  React.useEffect(() => {
    const nextHash = JSON.stringify(props.triggerValues);
    if (nextHash !== hashTriggers) {
      setHashTrigger(nextHash);
    }
  }, [props.triggerValues]);

  return <ExportContext.Provider value={builder}>
    {children}
  </ExportContext.Provider>
}